import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { AlertDialogConfigs } from "../../classes/AlertConfig";
import { useNavigate } from "react-router-dom";

interface AlertDialogProps {
  alertConfig: AlertDialogConfigs;
}

export default function AlertDialog(props: AlertDialogProps) {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const { alertConfig } = props;

  const handleClose = () => {
    setOpen(false);
  };

  const performPrimaryBtnAction = () => {
    alertConfig.primaryBtnAction().then((res) => {
      console.log("✅ primary button action complete!");
      navigate("/");
    });
  };

  React.useEffect(() => {
    setOpen(alertConfig.isOpen);
  }, [alertConfig]);

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{alertConfig.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {alertConfig.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{alertConfig.secondaryBtnText}</Button>
          <Button onClick={performPrimaryBtnAction} autoFocus>
            {alertConfig.primaryBtnText}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
